import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";          // new styles
import { login } from "./api";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw]     = useState(false);
  const [loading, setLoading]   = useState(false);
  const [errMsg, setErrMsg]     = useState("");
  const navigate = useNavigate();

  const disabled = !username || !password || loading;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setLoading(true);

    try {
      const { token } = await login(username, password);
      localStorage.setItem("token", token);     // or cookie!
      navigate("/");
    } catch (err) {
      setErrMsg("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="login-wrapper">
      <form className="login-card" onSubmit={handleSubmit}>
        <img src="/logoFAM.png" alt="" className="login-logo" />
        <h2>Welcome back</h2>
        <p className="login-sub">Sign in to your family files</p>

        {errMsg && (
          <div className="error-banner" aria-live="polite">
            {errMsg}
          </div>
        )}

        <label>
          Username
          <input
            autoFocus
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value.trim())}
          />
        </label>

        <label className="pw-wrap">
          Password
          <input
            type={showPw ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="button"
            className="pw-toggle"
            onClick={() => setShowPw((s) => !s)}
            aria-label={showPw ? "Hide password" : "Show password"}
          >
            {showPw ? "🙈" : "👁"}
          </button>
        </label>

        <button type="submit" disabled={disabled}>
          {loading ? "Logging in…" : "Log In"}
        </button>
      </form>
    </main>
  );
}
